<template>
  <aside class="sidebar" dir="rtl">
    <nav>
      <ul class="menu">
        <h3>أكاديمية الدكتور</h3>
        <hr />
        <li
          v-for="item in menuItems"
          :key="item.name"
          :class="{ active: isActive(item.route) }"
        >
          <router-link :to="item.route">
            <!-- استخدام أيقونة Font Awesome عبر الخاصية iconClass -->
            <i :class="item.iconClass"></i>
            <span class="label">{{ item.label }}</span>
          </router-link>
        </li>
      </ul>
      <!-- زر تسجيل الخروج -->
      <button type="button" class="btn btn-primary" @click="logout">
        تسجيل خروج
      </button>
    </nav>
  </aside>
</template>

<script>
export default {
  name: "AppSidebar",
  data() {
    return {
      // قائمة عناصر الشريط الجانبي مع أيقونات Font Awesome المناسبة
      menuItems: [
        { name: "DashboardPage", label: "الرئيسية", route: "/DashboardPage", iconClass: "fas fa-home" },
        { name: "categoryPage", label: "إدارة التصنيفات", route: "/categoryPage", iconClass: "fas fa-list-alt" },
        { name: "couponPagemanagement", label: "إدارة الكوبونات", route: "/couponPage", iconClass: "fas fa-ticket-alt" },
        { name: "coursePagemanagement", label: "إدارة الكورسات", route: "/coursePage", iconClass: "fas fa-book" },
        { name: "CourseVideos", label: "الفيديوهات", route: "/CourseVideos", iconClass: "fas fa-book" },
        { name: "newsPagemanagement", label: "إدارة الأخبار", route: "/newsPage", iconClass: "fas fa-newspaper" },
        { name: "sliderPagemanagement", label: "إدارة السلايدرات", route: "/sliderPage", iconClass: "fas fa-images" },
        { name: "universityPagemanagement", label: "إدارة الجامعات", route: "/universityPage", iconClass: "fas fa-university" },
        { name: "userManagement", label: "إدارة المستخدمين", route: "/userpage", iconClass: "fas fa-users" },
        { name: "managingsystemuserspage", label: "إدارة مستخدمين النظام", route: "/managingsystemuserspage", iconClass: "fas fa-users" },
        { name: "transctionspage", label: "المعاملات", route: "/transctionspage", iconClass: "fas fa-money-check-alt" },
        { name: "PurchasedCoursesPage", label: "الكورسات المشتراة", route: "/purchasedcourses", iconClass: "fas fa-shopping-cart" },
      ],
    };
  },
  methods: {
    // التحقق من العنصر النشط
    isActive(route) {
      return this.$route.path === route;
    },
    // دالة تسجيل الخروج
    logout() {

      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
/* التصميم الحالي */
.sidebar {
  width: 250px;
  background-color: #002f49;
  color: #fff;
  min-height: 100vh;
  position: fixed;
  right: 0;
  top: 0;
  padding: 20px;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
}

.menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu h3 {
  margin-bottom: 10px;
  text-align: center;
  font-size: 20px;
}

.menu hr {
  margin-bottom: 15px;
  border: 1px solid #fff;
}

.menu li {
  margin-bottom: 15px;
}

.menu li a {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
  padding: 10px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.menu li a:hover {
  background-color: #001f33;
}

.menu li.active a {
  background-color: #001f33;
  font-weight: bold;
}

.icon {
  margin-left: 10px;
  font-size: 18px;
}

.label {
  margin-right: 10px;
}

.btn-primary {
  width: 100%;
  background-color: #001f33;
  border: none;
  padding: 12px;
  font-size: 16px;
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 2rem;
}

.btn-primary:hover {
  background-color: #ffc007;
}
</style>